export enum EcoMailTag {
    REGISTRATION = 'registration',
    NEWSLETTER = 'newsletter',
    ORDER = 'order',
}
